import React from 'react';
import { Paper, Typography } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';






export function ValidationTile(props: any) {
  

  return (

      <Paper elevation={3} sx={{pl:4,pr:4, width:"15rem",height:"6rem", display: 'flex', flexDirection: 'row', alignItems: 'center',justifyContent:"space-between",borderRadius:"10px"}}>
        <div style={{display:"flex", flexDirection:"column"}}>
        <Typography variant="subtitle2" sx={{ mb: 1,fontWeight:'bold' }}>
          {props.heading}
        </Typography>
        <Typography variant="body1"  color={props.heading === 'Failure' ? 'error' : 'primary'} sx={{ mb: 1,fontWeight:"bold" }}>
          {props.count}
        </Typography>
        </div>
      
        {props.heading === 'Failure' ? (
        <Cancel color="error" sx={{fontSize:"3.5rem"}} />
      ) : (
        <CheckCircle sx={{ color: '#24c6b1',fontSize:"3.5rem" }}  />
      )}
      
      </Paper>
  
  );
};

export default ValidationTile;
